

import React, {Fragment, useState} from 'react';


import { Dialog, Grid, } from '@mui/material'

const LocationMap = ({ maxWidth, button}) => {
    const [openMap, setOpenMap] = useState(false);
    const [openPhoto, setOpenPhoto] = useState(false);


    function handleClickOpenMap() {
        setOpenMap(true);
    }

    function handleCloseMap() {
        setOpenMap(false);
    }
    function handleOpenPhoto() {
        setOpenPhoto(true);
    }
    function handleClosePhoto() {
        setOpenPhoto(false);
    }


    return (
        <Fragment>
            <button
                // className={`btn-w ${buttonClass}`}
                className='btn-w'
                onClick={handleClickOpenMap}>
                {button}
                Τοποθεσία στο χάρτη
            </button>
            <br/>
            <button
                // className={`btn-w ${buttonClass}`}
                className='btn-w mt-2'
                onClick={handleOpenPhoto}>
                {button}
                Δείτε τη φωτογραφία
            </button>
            <Dialog
                open={openMap}
                onClose={handleCloseMap}
                className="modalWrapper quickview-dialog"
                maxWidth={maxWidth}
            >
              <button onClick={handleCloseMap} className='event-close-btn'>
                <i  className='fa fa-close'></i>
              </button>
                <Grid className="modalBody modal-body">
                    <Grid className="modalBody modal-body">

                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3209.6279372808663!2d33.8778566!3d35.0844048!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14dfcbf99a532445%3A0x782baa84a67a67c0!2sLitsas%20Supermarket!5e1!3m2!1sel!2sgr!4v1738571715457!5m2!1sel!2sgr" 
                        width="600" 
                        height="450" 
                        style={{ border: 0 }} 
                        allowFullScreen="" 
                        loading="lazy" 
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Maps Location"
                    ></iframe>
                    </Grid>
                </Grid>
            </Dialog>

            <Dialog
                open={openPhoto}
                onClose={handleOpenPhoto}
                className="modalWrapper quickview-dialog"
                maxWidth={maxWidth}
            >
              <button onClick={handleClosePhoto} className='event-close-btn c-mt-box'>
                <i  className='fa fa-close'></i>
              </button>
                
                    <img src="/images/events/hint_map.png" alt="w" />
                 
            </Dialog>
        </Fragment>
    );
}
export default LocationMap


